import React from 'react';
import { Button, Modal } from 'antd';
import { Visitor } from 'core/visitRequestReview/types';

interface ReviewVisitorModalProps {
    visible: boolean;
    visitors: Visitor[];
    loading: boolean;
    onApprove: () => void;
    onReject: () => void;
    onCancel: () => void;
}

const labelStyle: React.CSSProperties = { fontWeight: 700, color: '#2B2D42', minWidth: 200, fontSize: 18 };
const valueStyle: React.CSSProperties = { color: '#2B2D42', fontSize: 18 };
const rowStyle: React.CSSProperties = { display: 'flex', padding: '6px 0' };

const ReviewVisitorModal: React.FC<ReviewVisitorModalProps> = ({ visible, visitors, loading, onApprove, onReject, onCancel }) => {
    if (visitors.length === 0) return null;

    return (
        <Modal
            open={visible}
            onCancel={onCancel}
            footer={null}
            width={650}
            title="Review Visitor"
            wrapClassName="review-visitor-modal">
            <div style={{ padding: '16px 0' }}>
                {visitors.map((visitor) => (
                    <div key={visitor.id} style={{ border: '1px solid #DEE2E6', borderRadius: 8, padding: 20, marginBottom: 24 }}>
                        <div style={{ fontSize: 18, fontWeight: 400, color: '#2B2D42' }}>
                            {visitor.name}
                        </div>
                        <div style={rowStyle}>
                            <span style={labelStyle}>Phone Number:</span>
                            <span style={valueStyle}>{visitor.phoneNumber || '-'}</span>
                        </div>
                        <div style={rowStyle}>
                            <span style={labelStyle}>Email Address:</span>
                            <span style={valueStyle}>{visitor.maskedEmail || visitor.email}</span>
                        </div>
                        {visitor.companyName && (
                            <div style={rowStyle}>
                                <span style={labelStyle}>Company Name:</span>
                                <span style={valueStyle}>{visitor.companyName}</span>
                            </div>
                        )}
                        {visitor.nsipReference && (
                            <div style={rowStyle}>
                                <span style={labelStyle}>NSIP Reference:</span>
                                <span style={valueStyle}>{visitor.nsipReference}</span>
                            </div>
                        )}
                    </div>
                ))}
                <div className="action-modal-buttons">
                    <Button
                        type="primary"
                        className="action-confirm-button"
                        onClick={onApprove}
                        loading={loading}>
                        Approve Visitor
                    </Button>
                    <Button
                        className="action-cancel-button"
                        onClick={onReject}
                        disabled={loading}>
                        Reject Request
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default ReviewVisitorModal;
